
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [

  { field: "shop", label: "SHOP", align: "left" },
  { field: "actual_L", label: "Actual O/C Labour ", align: "right" },
  { field: "dist_L", label: "Distributed O/C Labour", align: "right" },
  { field: "uo_L", label: "U/O Charge (O/C Labour)", align: "right" },
  { field: "actual_S", label: "Actual O/C Store ", align: "right" },
  { field: "dist_S", label: "Distributed O/C Store", align: "right" },
  { field: "uo_S", label: "U/O Charge (O/C Store)", align: "right" },




];

export default function WGRTable({ rows }) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align={column.align}
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                  whiteSpace: "nowrap",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => {

            const uo_Labour =
              Number(row["ACTUAL ON COST LABOUR"] || 0) -
              Number(row["DISTRIBUTED ON COST LABOUR"] || 0);

            const uo_Store =
              Number(row["ACTUAL ON COST STORE"] || 0) -
              Number(row["DISTRIBUTED ON COST STORE"] || 0);


            // console.log(totalLabour);

            return (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    bgcolor: "grey.50",
                  },
                }}
              >

                <TableCell align="left" sx={{ paddingLeft: "100px" }}>
                  {row.SHOPCODE}
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={row["ACTUAL ON COST LABOUR"]}
                  />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={row["DISTRIBUTED ON COST LABOUR"]}
                  />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={uo_Labour}
                  />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell
                    value={row["ACTUAL ON COST STORE"]}
                  />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={row["DISTRIBUTED ON COST STORE"]}
                  />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={uo_Store}
                  />
                </TableCell>




              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

